import React, { useState, useEffect } from 'react';
import { format, addDays, startOfToday } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import Icon from '../../../components/AppIcon';

const DateSelector = ({ selectedDate, setSelectedDate, validationErrors }) => {    
  const [availableDates, setAvailableDates] = useState([]);

  useEffect(() => {
    // Generate next 14 days
    const today = startOfToday();
    const dates = [];
    
    for (let i = 0; i < 14; i++) {
      const date = addDays(today, i);
      const dayOfWeek = date?.getDay();
      
      // Skip Sundays (0)
      if (dayOfWeek === 0) continue;
      
      dates?.push({
        date: format(date, 'yyyy-MM-dd'),
        displayDate: format(date, 'dd/MM'),
        day: format(date, 'EEE', { locale: ptBR }),
        fullDate: date,
        available: true
      });
    }
    
    setAvailableDates(dates);
  }, []);

  const handleDateSelect = (dateItem) => {
    if (dateItem?.available) {
      const selectedDate = new Date(dateItem.date + "T12:00:00");
      setSelectedDate(new Date(selectedDate)); 

    }
  };

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
        <Icon name="Calendar" size={20} color="var(--color-primary)" />
        Selecione uma data
      </h3>
      {validationErrors?.selectedDate && (
        <p className="text-sm text-destructive mb-3 flex items-center gap-1">
          <Icon name="AlertCircle" size={14} color="var(--color-destructive)" />
          {validationErrors?.selectedDate}
        </p>
      )}
      <div className="grid grid-cols-7 gap-2">
        {availableDates?.map((dateItem, index) => (
          <button
            key={index}
            type="button"
            onClick={() => handleDateSelect(dateItem)}
            disabled={!dateItem?.available}
            className={`p-3 rounded-lg text-center transition-all ${
              selectedDate === dateItem?.date
                ? 'bg-primary text-primary-foreground shadow-md scale-105'
                : dateItem?.available
                ? 'bg-muted hover:bg-muted/80 text-foreground hover:scale-105'
                : 'bg-muted/50 text-muted-foreground cursor-not-allowed opacity-50'
            }`}
          >
            <div className="text-xs font-medium mb-1 capitalize">{dateItem?.day}</div>
            <div className="text-sm font-semibold">
              {dateItem?.displayDate?.split('/')?.[0]}
            </div>
          </button>
        ))}
      </div>
      {selectedDate && (
        <div className="mt-4 p-4 bg-primary/10 rounded-lg">
          <p className="text-sm text-foreground">
            <strong>Data selecionada:</strong>{' '}
            {format(selectedDate, "d 'de' MMMM 'de' yyyy", { locale: ptBR })}
          </p>
        </div>
      )}
    </div>
  );
};

export default DateSelector;